import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@img/recharge-success.png'


const _withScopeId = n => (_pushScopeId("data-v-53383faf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = ["data-loading", "data-error"]
const _hoisted_3 = { class: "user-info" }
const _hoisted_4 = { class: "username" }
const _hoisted_5 = { class: "userId" }
const _hoisted_6 = { class: "type-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "recharge-type-display" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "info" }
const _hoisted_12 = { class: "num" }
const _hoisted_13 = { class: "price" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "Recharged successfully", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Payment = _resolveComponent("Payment")!
  const _component_CusModal = _resolveComponent("CusModal")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createBlock(_component_CusModal, {
    zindex: 9999,
    isShow: _ctx.isShowRecharge,
    width: "600px",
    onOnClose: _ctx.hideRecharge
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["recharge-box", { isUserPaySuccess: _ctx.isUserPaySuccess }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _withDirectives(_createElementVNode("img", {
            "data-loading": require('@img/default-avatar.png'),
            "data-error": require('@img/default-avatar.png'),
            alt: ""
          }, null, 8, _hoisted_2), [
            [_directive_lazy, _ctx.userInfo.icon]
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.userInfo.nickname), 1),
            _createElementVNode("div", _hoisted_5, "ID " + _toDisplayString(_ctx.userInfo.id2), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Buy Coins', 'Buy Gems'], (item, idx) => {
            return _createElementVNode("div", {
              class: _normalizeClass(["item", { active: _ctx.rechargeTypeIdx === idx }]),
              key: item,
              onClick: ($event: any) => (_ctx.selectRechargeTypeIdx(idx))
            }, _toDisplayString(item), 11, _hoisted_7)
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rechargeTypeIdx
            ? _ctx.rechargeGemList
            : _ctx.rechargeGoldList, (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["item", { active: _ctx.rechargeIndex === idx }]),
              key: _ctx.rechargeTypeIdx ? item.gemCardId : item.id,
              onClick: ($event: any) => (_ctx.setRechargeIndex(idx))
            }, [
              _createElementVNode("img", {
                src: 
              require(`@img/${
                _ctx.rechargeTypeIdx ? 'icon-gems' : 'icon-more-golds'
              }.png`)
            ,
                alt: ""
              }, null, 8, _hoisted_10),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.rechargeTypeIdx
                  ? item.gems
                  : `${item.golds}${
                      item.giveawayGolds ? ` + ${item.giveawayGolds}` : ""
                    }`), 1),
                _createElementVNode("div", _hoisted_13, "USD " + _toDisplayString(_ctx.formatFloatNum(item.amount / 100)), 1)
              ])
            ], 10, _hoisted_9))
          }), 128))
        ]),
        _createVNode(_component_Payment, {
          "goods-id": _ctx.goodsId,
          kind: 1,
          onGotoRecharge: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectRechargeTypeIdx(1)))
        }, null, 8, ["goods-id"]),
        _createElementVNode("div", {
          class: _normalizeClass(["recharge-success", { active: _ctx.isUserPaySuccess }])
        }, [
          _hoisted_14,
          _hoisted_15,
          _createElementVNode("div", {
            class: "btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.continueToRecharge && _ctx.continueToRecharge(...args)))
          }, "Continue to recharge")
        ], 2)
      ], 2)
    ]),
    _: 1
  }, 8, ["isShow", "onOnClose"]))
}